export default "__VITE_ASSET__js13BvoO__"